/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admincredit_Coluser2Inputs */

const zh_admincredit_coluser2 = /** @type {(inputs: Admincredit_Coluser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户`)
};

const en_admincredit_coluser2 = /** @type {(inputs: Admincredit_Coluser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

const es_admincredit_coluser2 = /** @type {(inputs: Admincredit_Coluser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Admincredit_Coluser2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const admincredit_coluser2 = /** @type {((inputs?: Admincredit_Coluser2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admincredit_Coluser2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_admincredit_coluser2(inputs)
	if (locale === "en") return en_admincredit_coluser2(inputs)
	return es_admincredit_coluser2(inputs)
});
export { admincredit_coluser2 as "adminCredit_colUser" }